/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'

const $t = sign => Vue.prototype.i18n.t(sign)

export default {
  getUnitPriceType (state) {
    if (state.requirements && state.requirements.hasOwnProperty('unitPriceVatInc')) {
      return `(${$t(state.requirements.unitPriceVatInc ? 'others.global.vatInc' : 'others.global.vatExc')})`
    } else {
      return ''
    }
  }
}
